interface ExitIntentConfig {
  documentTopOffset: number;
  delay: number;
  onExitIntent: () => void;
}

export default class ExitIntentBuilder {
  private callback: (event: MouseEvent) => void;
  private delayTimeout: number | undefined;

  constructor(private config: ExitIntentConfig) {
    this.callback = this.onMouseMove.bind(this);
    document.addEventListener('mousemove', this.callback, false);
  }

  private onMouseMove(event: MouseEvent): void {
    if (event.clientY <= this.config.documentTopOffset) {
      if (!this.delayTimeout) {
        this.delayTimeout = setTimeout(() => {
          this.cancelListener();
          this.config.onExitIntent();
        }, this.config.delay);
      }
    } else {
      this.clearCurrentTimeout();
    }
  }

  private clearCurrentTimeout(): void {
    this.delayTimeout && clearTimeout(this.delayTimeout);
    this.delayTimeout = undefined;
  }

  cancelListener(): void {
    document.removeEventListener('mousemove', this.callback, false);
  }
}
